// extracted by mini-css-extract-plugin
export default {"subTitile":"HallsTime_subTitile__x2Ebs","link":"HallsTime_link__LrNBo","button":"HallsTime_button__iG454"};